import { Currency, useMutation, useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useForm } from '@sequencehq/utils'
import { useNotifications } from '@sequencehq/core-components'

export const useCurrencySettings = () => {
  const { data, isLoading, isError } = useQuery(
    dashboard20240730Client.getSequenceAccountSettings,
    undefined,
    {
      select: res => res?.enabledCurrencies ?? []
    }
  )

  const { fields } = useForm({
    value: {
      enabledCurrencies: data ?? []
    },
    fieldConfiguration: [
      {
        property: 'enabledCurrencies',
        validation: []
      }
    ]
  })

  const { displayNotification } = useNotifications()

  const mutator = useMutation(
    dashboard20240730Client.putSequenceAccountSettings,
    {
      onSuccess() {
        displayNotification('Currencies updated', {
          type: 'success'
        })
      },
      onError() {
        displayNotification('Currencies failed to update', {
          type: 'error'
        })
      }
    }
  )

  const updateEnabledCurrency = (code: Currency, enabled: boolean) => {
    if (mutator.isPending) return

    const newValue = enabled
      ? [...fields.enabledCurrencies.value, code]
      : fields.enabledCurrencies.value.filter(value => value !== code)

    fields.enabledCurrencies.onChange(newValue)
    mutator.mutate({ enabledCurrencies: newValue })
  }

  return {
    enabledCurrencies: fields.enabledCurrencies.value,
    updateEnabledCurrency,
    isLoading,
    isError
  }
}
